import * as z from "zod/v4";

// HA-939 AC4: what is typed from the label is checked before anything is sent. The server normalises the same way
// (ignore case and spaces; the MAC with ":", "-", "." or no separators) and is the authority.

export const MAC_ERROR =
	"Enter the MAC address as shown on the label, e.g. 2c:cf:67:67:bb:5f";
export const SERIAL_ERROR = "Enter the serial number as shown on the label";

/** Lowercase, colon-separated; null when it isn't 12 hex characters once separators are removed. */
export function normaliseMac(raw: string): string | null {
	const compact = raw.trim().replace(/[:.-]/g, "").toLowerCase();
	if (!/^[0-9a-f]{12}$/.test(compact)) return null;
	return compact.match(/.{2}/g)!.join(":");
}

/** Lowercase hex; null when empty, "unknown" or not hex. */
export function normaliseSerial(raw: string): string | null {
	const value = raw.trim().toLowerCase();
	if (value === "" || value === "unknown") return null;
	return /^[0-9a-f]+$/.test(value) ? value : null;
}

export const macSchema = z
	.string()
	.refine((v) => normaliseMac(v) !== null, MAC_ERROR);

export const serialSchema = z
	.string()
	.refine((v) => normaliseSerial(v) !== null, SERIAL_ERROR);

/** The four ways a link is refused, in the label flow's words, by the code the server answers with. */
export const LINK_REFUSALS: Record<string, string> = {
	PRINT_PROXY_NOT_FOUND:
		"We couldn't find a print proxy with that MAC address and serial number. Check the label and try again.",
	PRINT_PROXY_NEEDS_UPDATE:
		"This print proxy needs a software update before it can be linked. Contact support.",
	PRINT_PROXY_LINKED_ELSEWHERE:
		"This print proxy is already linked to another account. Contact support.",
	PRINT_PROXY_ALREADY_LINKED:
		"This print proxy is already linked to your account.",
};
